<template lang="html" >
    <vs-popup :active.sync="$props.popupActive" title="Lemlist Activités" :style="{zIndex: $props.zIndex}">
        <vs-table
		stripe pagination max-items="25"
		:data="$props.activites"
		:max-height= "tableHeight + 'px'"
		id="tb"
        ref="indexable-table"
		noDataText="Aucune activités corresponde"
    >
	<!-- <template slot="header">
        <h3>
            Non indexable
        </h3>
      </template> -->
    <template slot="thead">
	<vs-th class="th-sticky" sort-key="name">Date</vs-th>
	<vs-th class="th-sticky pdl0" sort-key="priority">Activité</vs-th>
</template>

    <template slot-scope="{data}">
	<vs-tr :key="index" v-for="(activity, index) in data">
		<vs-td style="width: 10%" :data="activity.typeObject.icon_name">
			{{ convertToReadableDate(activity.createdAt) }}
		</vs-td>
		<vs-td style="width: 10%" :data="activity.typeObject.text">
			<vs-icon
				:icon="activity.typeObject.icon_name"
				:color="activity.typeObject.color"
			/>
			{{ activity.typeObject.text }}
		</vs-td>
	</vs-tr>
</template>
    </vs-table>
             <!-- </vx-card> -->
            </vs-popup>
         </template>

	<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import moment from "moment";
//import utilsMixin from "@/mixins/utilsMixin.js";
import CircularLoader from "../../../widgets/loader/CircularLoader.vue";
export default {
	created() {
		//getting orders which belongs to user sign in
	},
	updated() {
		// //console.log("dsadsads");
		// this.getNotes();
	},
	components: { CircularLoader },
	mounted() {},
	name: "LemlistHistoryActivityPopup",
	mixins: [dbFieldConvertor],
	props: {
		popupActive: {
			type: Boolean,
			required: true,
		},
		activites: {
			type: Array,
			required: true,
		},
		zIndex: {
			type: Number,
			required: true,
			default: 1000,
		},
	},

	data() {
		return {
			// apiUrl: this.$store.state.backendApiUrl,
			// internalTabs: [],
			// isLoading: false,
		};
	},
	computed: {
		// allCollaboratorsAvatar: () => {
		// 	return store.state.collaborators_avatar;
		// },
		// allCollaborators: () => {
		// 	return store.state.collaborators;
		// },
		// activeUser: () => {
		// 	return VueCookies.get("userInfo");
		// },
		// apiUrl: () => {
		// 	return store.state.backendApiUrl;
		// },
	},
	methods: {
		convertToReadableDate(date) {
			return moment(date).format("DD/MM/YYYY");
		},
	},
};
</script>
